import Audio from "@frog/source/utility/Audio.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"

export default {
    "slug": "dice",
    "title": "Dice Tactics",
    "firstChapterKey": "ch0",
    "introduction": "a game for Pigsquad's BYOG Jam",
    "player": require("./player.jsx").default,
    "chapters": {
        "ch0": require("./ch0").default,
        "chX": require("./chX").default,
    },
    "configuration": {
        "darkness": "none",
    },
    "credits": [
        "Andrew Goodenough",
        "Hypnotic Fox",
        "Ed Varga",
    ],
    "analytics": {
        "gameKey": "43aaebfecc7041c958c6cd224503fda8",
        "secretKey": "21ccf31dda5f4de6bda15cfa55358e9ef65e6589",
    },
    "unitJobs": require("./unitJobs.jsx").default,
    "images": {
        // ...
    },
    "audio": {
        "Dice:Roll": {
            "volume": 0.3,
            "type": "once:rotation",
            "audio": [
                new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Player_rolling.wav")),
                new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Player_rolling_lighter.wav")),
            ],
        },
        "Music:1A": {
            "volume": 0.37,
            "label": "music",
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_1A_dice_roll_loop.wav")),
                new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_1A_battle_loop.wav")),
            ],
            "kill": {"label": "music"},
        },
        "Music:1B": {
            "volume": 0.37,
            "label": "music",
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_1B_dice_roll_loop.wav")),
                new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_1B_battle_loop.wav")),
            ],
            "kill": {"label": "music"},
        },
        "Music:2": {
            "volume": 0.37,
            "label": "music",
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_2_dice_roll_loop.wav")),
                new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_2_battle_loop.wav")),
            ],
            "kill": {"label": "music"},
        },
        "Music:Boss": {
            "volume": 0.37,
            "label": "music",
            "type": "simultaneously",
            "func": FadeInOutWhilePlaying,
            "loop": true,
            "audio": [
                new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_boss_level_dice_roll_loop.wav")),
                new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_track_boss_level_battle_loop.wav")),
            ],
            "kill": {"label": "music"},
        },
        "Stinger:Success": {
            "volume": 0.37,
            "label": "music",
            "type": "once",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_win_stinger.wav")),
            "kill": {"label": "music"},
        },
        "Stinger:Failure": {
            "volume": 0.37,
            "label": "music",
            "type": "once",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/musics/Dice_Tactics_lose_stinger.wav")),
            "kill": {"label": "music"},
        },
        "Stinger:Start": {
            "volume": 0.37,
            "label": "music",
            "type": "once",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Game_Start.wav")),
            "kill": {"label": "music"},
        },
        "Stinger:PlayerTurn": {
            "volume": 0.37,
            "type": "once",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Game_Player_Phase.wav")),
        },
        "Stinger:EnemyTurn": {
            "volume": 0.37,
            "type": "once",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Game_Enemy_Phase.wav")),
        },
        "Ambience": {
            "volume": 0.4,
            "loop": true,
            "label": "ambience",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Dungeon_Ambience_Loop.wav")),
        },
        "Attack:Goblin": {
            "volume": 0.3,
            "type": "once",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Unit_Goblin_Attack.wav")),
        },
        "Attack:Skeleton": {
            "volume": 0.3,
            "type": "once",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Unit_Skeleton_Attack.wav")),
        },
        "Attack:Slime": {
            "volume": 0.33,
            "type": "once",
            "audio": new Audio(require("@frog/source/assets/audio/dice-tactics/sounds/Unit_Slime_Attack.wav")),
        },
    }
}

function FadeInOutWhilePlaying(stage) {
    if(this.audio[0].paused != true) {
        if(Math.abs(this.audio[0].currentTime - this.audio[1].currentTime) > 0.1) {
            this.audio[1].currentTime = this.audio[0].currentTime
            console.warn("AUDIO DESYNC")
        }
    }

    if(stage.player.phase != "playing") {
        this.audio[1].volume = tween(this.audio[1].volume, 0)
    } else {
        this.audio[1].volume = tween(this.audio[1].volume, this.audio[0].volume)
    }
}

function tween(currentValue, intendedValue) {
    const rate = Math.abs(intendedValue - currentValue) / 2
    if(rate < 0.01) {
        currentValue = intendedValue
    } else if(currentValue < intendedValue) {
        currentValue += rate
        currentValue = Math.min(currentValue, intendedValue)
    } else if(currentValue > intendedValue) {
        currentValue -= rate
        currentValue = Math.max(currentValue, intendedValue)
    }
    return currentValue
}
